import { Injectable } from '@angular/core';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { IconName, IconPrefix } from '@fortawesome/fontawesome-svg-core';
import { far } from '@fortawesome/pro-regular-svg-icons';
import { fal } from '@fortawesome/pro-light-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { fas } from '@fortawesome/pro-solid-svg-icons';

@Injectable({
  providedIn: 'root',
})
export class FontAwesomeService {
  constructor(private library: FaIconLibrary) {
    this.library.addIconPacks(fal, far, fab, fas);
  }

  checkIconAvailable(prefix: string, name: string): boolean {
    return (
      this.library.getIconDefinition(prefix as IconPrefix, name as IconName) !==
      null
    );
  }
}
